import aff from './aff.png'
export default function () {
  return (
    <div className="banner-inner flex flex-col md:flex-row px-8 pt-4 sticky top-0 bg-white z-50">
      <div className="brand mb-0">
        <img src={aff} alt="Australian Frequent Flyer Logo" className="h-10" />
      </div>
    </div>
  )
}
